export const device = {
    mounted : function () {
        this.logDeviceType();
    },
    data : function () {
        return {
            type : ''
        };
    },
    methods : {
        logDeviceType : function () {
            if (this.$root.device) {
                let device = this.$root.device;
                console.debug(device.platform);
                return ;
            }
            console.debug('NO DEVICE');
        },
        cordovaError : function (error) {
            console.error('Media not captured', error);
        },
        mediaUploaded : function () {
            this.$parent.mediaUploaded();
        },
        mediaUploading : function () {
            this.$parent.mediaUploading();
        },
        mediaToFile : function (media) {
            if (!media || !media.name) {
                console.debug('Media has no name', media);
                return;
            }
            var file = new File(media.name, media.localURL, media.type, media.lastModifiedDate, media.size);
            this.setMedia(file);
        },
        fileUrlToBlob : function (media) {
            let self = this;
            // console.log('MEDIA 0', media);
            // console.debug('MEDIA TYPE', typeof media);
            if (typeof media == 'string') {
                self.mediaUploading();
                // uploaded videos are missing the file:// protocol
                // console.log('media 1', media);
                if (media.substring(0, 4) != 'file') {
                    media = 'file://' + media;
                }
                // console.log('media 2', media);
                window.resolveLocalFileSystemURL(media, function(fileEntry) {
                    return fileEntry.file(function(data) {
                        // console.log('data', data);
                        self.mediaUploaded();
                        self.setMedia(data);
                    });
                }, function (error) {
                    console.debug('Error resolveLocalFileSystemURL', error);
                    self.mediaUploaded();
                });
            } else {
                this.mediaToFile(media);
            }
        },
        cordovaUpload : function (mediaFiles) {
            let media = mediaFiles[0];
            let self = this;
            if (typeof media == 'string') {
                this.mediaUploading();
                // uploaded videos are missing the file:// protocol
                if (media.substring(0, 4) != 'file') {
                    media = 'file://' + media;
                }
                window.resolveLocalFileSystemURL(media, function(fileEntry) {
                    return fileEntry.file(function(data) {
                        self.mediaUploaded();
                        self.setMedia(data);
                    });
                }, function (error) {
                    console.debug('Error resolveLocalFileSystemURL', error);
                    self.mediaUploaded();
                });
            } else {
                this.mediaToFile(media);
            }
        },
    },
    computed : {
        buttonAction : function () {
            var action = 'Upload ';
            if (this.isCordova) {
                action = 'Record ';
                if (this.type == 'image') {
                    action = 'Take ';
                }
            }
            return action;
        },
        buttonText : function () {
            let action = this.buttonAction;
            if (this.type == 'audio') {
                return action + 'Audio';
            }
            else if (this.type == 'video') {
                return action + 'Video';
            }
            else if (this.type == 'image') {
                return action + 'Photo';
            }
            return action + 'Media';
        },
        isCordova : function () {
            if (this.$root.device) {
                return true;
            }
            return false;
        },
        isWebsite : function () {
            return !this.isCordova;
        },
        isIos : function () {
            if (this.isCordova) {
                let device = this.$root.device;
                return device.platform == 'iOS';
            }
            return false;
        },
        isAndroid : function () {
            if (this.isCordova) {
                let device = this.$root.device;
                return device.platform == 'Android';
            }
            return false;
        },
    }
};
